import { ChangeDetectionStrategy, Component, computed, inject, input, output } from '@angular/core';
import { CommonModule } from '@angular/common';
import { BackBtnComponent } from '@pc/back-btn';
import { FooterComponent } from '@pc/footer';
import { GradientBtnComponent } from '@pc/gradient-btn';
import { TranslateModule } from '@ngx-translate/core';
import { FooterModel } from './footer.model';
import { SeparatorComponent } from '@pc/separator';
import { QuoteOverviewComponent } from '../quote-overview/quote-overview.component';
import { pxToRem, QuoteOverviewLabels } from '@pc/shared';
import { QuoteOverviewService } from '../../shared/services/quote/quote-overview.service';

@Component({
  selector: 'pc-app-footer',
  standalone: true,
  imports: [
    CommonModule,
    BackBtnComponent,
    FooterComponent,
    GradientBtnComponent,
    TranslateModule,
    SeparatorComponent,
    QuoteOverviewComponent
  ],
  templateUrl: './app-footer.component.html',
  styleUrl: './app-footer.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class AppFooterComponent {
  public quoteOverviewService = inject(QuoteOverviewService);

  public footerData = input.required<FooterModel | null>();
  public showQuoteOverviewFooter = input.required<boolean>();
  public isDisabled = input.required<boolean>();
  public totalPrice = input.required<number>();
  public quoteOverviewLabels = input.required<QuoteOverviewLabels>();
  public fData = computed(() => this.footerData() as FooterModel);
  public quoteTripDetailsData = computed(() => this.quoteOverviewService.quoteTripDetailsData());

  public nextClk = output();
  public backClk = output();

  public readonly SEPARATOR_HEIGHT = 42;
  protected readonly pxToRem = pxToRem;

  public onBackButtonClicked(): void {
    this.backClk.emit();
  }

  public onNextButtonClicked(): void {
    this.nextClk.emit();
  }
}
